import React from 'react';
import commingsoonimg from '../../../assets/images/commingsoonimg.svg';
import { Button } from 'react-bootstrap';

const Commingsoon: React.FC = () => {
    return (
        <>
            <div className="error_page">
                <div className="common_card">
                    <div className="page_not_found">
                        <div className="page_not_found_head">
                            <h1>Comming Soon</h1>
                        </div>
                        <div className="page_not_found_img">
                            <img src={commingsoonimg} alt="commingsoonimg" />
                        </div>
                        {/* <div className="page_not_found_btn">
                            <Button variant="primary">Bring To Home</Button>
                        </div> */}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Commingsoon;